import { TranslationField } from "~/components/TranslationField";
import { TimeElement } from "../TimeElement";
import { useDateWidget } from "../../../providers/dates/context";
import { useTranslation } from "~/primitives/translator";
import { createEffect, createSignal, Show } from "solid-js";
import { Group } from "~/components/ui/group";
import { Badge } from "~/components/ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "~/components/ui/dialog";
import { Button } from "~/components/ui/button";

export function EventDialog() {

	const { 
		formatDate, 
		setOpenContentDialog, 
		openContentDialog,
		event
	} = useDateWidget();
	
	const [
		content, 
		setContent
	] = createSignal<string>();

	const onClose = () => {
		setOpenContentDialog(false);
	};

	createEffect(() => {

		const contentProp = event()?.content;

		if (!contentProp) {
			setContent("");
			return;
		}

		useTranslation(contentProp).then(setContent);
	});

	return (
		<Dialog
			open={openContentDialog()}
			onOpenChange={onClose}
			withCloseButton={false}
		>
			<DialogContent class="py-4">
				<DialogHeader class="pt-0">
					<Group class="w-full" justify="between">
						<DialogTitle>
							<TranslationField key={event()?.title} />
						</DialogTitle>
						<TranslationField key={event()?.category.title}>
							{(value) => (
								<Badge 
									variant="default"								>
									{value()}
								</Badge>
							)}
						</TranslationField>
					</Group>
					<DialogDescription class="text-left">
						{formatDate(event())}
					</DialogDescription>
					<Show when={event()}>
						{(event) => <TimeElement event={event()} />}
					</Show>
				</DialogHeader>
				<div innerHTML={content()} />
				<Button class="mt-6" onClick={onClose}>
					Sluiten
				</Button>
			</DialogContent>
		</Dialog>
	);
}